import { render, staticRenderFns } from "./LeftArrowIcon.vue?vue&type=template&id=446af887"
var script = {}


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports